module.exports = __webpack_public_path__ + "img/reviews-img-3-test.14099308.jpg";